import { useEffect } from "react";
import { Head } from 'vite-react-ssg';

const ChromeExtensionUpdate = () => {
  useEffect(() => {
    window.location.href = "https://chromewebstore.google.com/detail/ai-sidebar-with-deepseek/inhcgfpbfdjbjogdfjbclgolkmhnooop";
  }, []);

  return (
    <>
      <Head>
        <title>Redirecting…</title>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://deepseek.ai/chrome-extension-update" />
      </Head>
      <div className="container mx-auto px-4 py-16 min-h-screen">
        <h1 className="text-3xl font-bold text-center mt-20">
          Redirecting...
        </h1>
      </div>
    </>
  );
};

export default ChromeExtensionUpdate;
